import { useContext } from 'react';
import { AuthContext, AuthContextProps } from 'modules/auth/contexts/authContext';

/**
 * Custom hook to get the auth context.
 * Use this hook in any function component that needs to access or modify auth tokens.
 */
export const useAuth = (): AuthContextProps => {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
};
